const getDate = (item) =>
{
    const node = item?.node || item;
    const dateItem = {
        dateUpdate: node?.cdmfields?.eat?.post_updated_date || '',
        dateCreation: node?.date,
    };
    const dateObj = dateItem.dateUpdate !== '' ? dateItem.dateUpdate : dateItem.dateCreation;
    return new Date(dateObj);
}
const dynamicSort = (order) =>
{
    const sortOrder = order === 'desc' ? -1 : 1;

    return (a, b) =>
    {
        let result;
        const date1 = getDate(a);
        const date2 = getDate(b);
        if (date1 < date2) result = -1;
        else if (date1 > date2) result = 1;
        else result = 0;
        return result * sortOrder;
    };
};

module.exports = dynamicSort;